import { cloneDeep } from 'lodash';
const state = {
  list: [],
  product: {},
  edit_product: {},
  resource_images: []
};

const getters = {
  list: (state) => {
    return state.list || [];
  },
  product: (state) => {
    return state.product || {};
  },
  edit_product: (state) => {
    return state.edit_product;
  },
  resource_images: (state) => {
    return state.resource_images || [];
  }
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_PRODUCT(state, product) {
    state.product = cloneDeep(product);
    state.edit_product = cloneDeep(product);

    const index = state.list.findIndex((x) => x.id === product.id);
    if (index < 0 && product.id) {
      state.list.push(cloneDeep(product));
    }
  },
  EDIT_PRODUCT(state, item) {
    state.edit_product = item;
  },
  SET_RESOURCE_IMAGES(state, list) {
    state.resource_images = list || [];
  }
};

const actions = {
  getAll({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('products/getAll')
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getByCategory({ commit }, categoryId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`products/getCategoryProducts?id=${categoryId}`)
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  set({ commit }, item) {
    commit('SET_PRODUCT', item);
  },
  get({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`products/get?id=${id}`)
        .then((response) => {
          commit('SET_PRODUCT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  edit({ commit }, item) {
    commit('EDIT_PRODUCT', item);
  },
  save({ commit }, item) {
    var isAdd = !item.id;
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('products/save', item)
        .then((response) => {
          if (!isAdd) {
            commit('SET_PRODUCT', response.data);
          }
          commit('lookup/SET_PRODUCT', response.data, { root: true });
          resolve(response.data.id);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setPrintProductMailable({ commit }, item) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(
          `products/setPrintProductMailable?coreProductId=${item.id}&printProductId=${item.printProductId}&mailable=${item.mailable}`
        )
        .then((response) => {
          commit('SET_PRODUCT', response.data);
          resolve(response.data.id);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  generateBlankCanvas({ commit }, productId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`products/generateBlankCanvas?productId=${productId}`)
        .then((response) => {
          commit('SET_PRODUCT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setModelUrl({ commit }, req) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', req.file);
      this._vm.$http
        .post(`products/setModelUrl?coreProductId=${req.coreProductId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          commit('SET_PRODUCT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setTemplateResourceUrl({ commit }, req) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', req.file);
      this._vm.$http
        .post(`products/setTemplateResourceUrl?coreProductId=${req.coreProductId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          commit('SET_PRODUCT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getResourceImages({ commit }, coreProductId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`products/getResourceImages?coreProductId=${coreProductId}`)
        .then((response) => {
          commit('SET_RESOURCE_IMAGES', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addResourceImage({ commit }, req) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', req.file);
      this._vm.$http
        .post(`products/addResourceImage?coreProductId=${req.coreProductId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          commit('SET_RESOURCE_IMAGES', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteResourceImage({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`products/deleteResourceImage?coreProductId=${req.coreProductId}&id=${req.id}`)
        .then((response) => {
          commit('SET_RESOURCE_IMAGES', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
